import { Component, OnInit, Injector, ViewEncapsulation, Injectable, Input } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { EventWorksServiceProxy } from '@shared/service-proxies/service-proxies';
import { EventWorkHelperService, IEventWorkSelected } from './event-work-helper-service';

@Component({
    templateUrl: './event-work-header.component.html',
    selector: '[eventWorkHeader]',
    encapsulation: ViewEncapsulation.None
})
@Injectable()
export class EventWorkHeaderComponent extends AppComponentBase implements OnInit {

    @Input() autoSelectLastEvent:boolean = false;

    eventWorkSelected: IEventWorkSelected = undefined;
    eventWorks = [];

    constructor(
        injector: Injector,
        private _eventWorksService: EventWorksServiceProxy,
        private _eventWorkHelper: EventWorkHelperService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.eventWorkSelected = this._eventWorkHelper.loadEventWorkSelected();
        this.loadEventWork();
        this.registerToEvents();
    }

    registerToEvents() {
        abp.event.on('app.eventWorkHeader.refresh', () => {
            this.loadEventWork();
        });
    }

    loadEventWork(): void {

        this.eventWorkSelected = this._eventWorkHelper.loadEventWorkSelected();

        this._eventWorksService.getAll(
            undefined,
            undefined,
            undefined,
            0,
            3
        )
        .subscribe(result => {

            this.eventWorks = result.items;

            if ((!this.eventWorkSelected && result.totalCount > 0) || this.autoSelectLastEvent) {

                let eventWork: IEventWorkSelected = {
                    id: result.items[0].eventWork.eventId,
                    name: result.items[0].eventName,
                    userId: this.appSession.user.id,
                    eventWorkId: result.items[0].eventWork.id
                };

                this.save(eventWork)
            }
        });
    }

    chooseEvent(item): void {

        let eventWork: IEventWorkSelected = {
            id: item.eventWork.eventId,
            name: item.eventName,
            userId: this.appSession.user.id,
            eventWorkId: item.eventWork.id
        };

        this.save(eventWork, true)
    }

    save(eventWork, reload?:boolean): void {

        this._eventWorkHelper.save(eventWork)
        this.eventWorkSelected = eventWork;

        if (reload) {
            window.location.reload();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/scientific-work/event-work-header/event-work-header.component.ts